// Configuração centralizada das URLs da API

// Função para detectar ambiente e configurar URL apropriada
const getWorkerURL = () => {
  // Em desenvolvimento, usar localhost ou worker direto
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_WORKER_API_URL || 
           'https://n8n-gama.pedropinto8400.workers.dev';
  }
  
  // Em produção, usar proxy relativo se disponível, senão worker direto
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Se estiver no domínio principal, usar proxy interno
    if (hostname === 'www.feedbackagencia.shop' || hostname === 'feedbackagencia.shop') {
      return ''; // URL relativa para proxy interno
    }
    
    // Se estiver no Cloudflare Pages, usar worker direto
    if (hostname.includes('pages.dev')) {
      return process.env.REACT_APP_WORKER_API_URL || 
             'https://n8n-gama.pedropinto8400.workers.dev';
    }
  }
  
  // Fallback para worker direto
  return process.env.REACT_APP_WORKER_API_URL || 
         'https://n8n-gama.pedropinto8400.workers.dev';
};

// URL do Cloudflare Worker para processar leads
export const WORKER_API_URL = getWorkerURL();

// Endpoints disponíveis
export const API_ENDPOINTS = {
  LEAD: '/api/lead',
  CONTACT: '/api/contact'
};

// URL completa para envio de leads
export const LEAD_API_URL = WORKER_API_URL ? 
  `${WORKER_API_URL}${API_ENDPOINTS.LEAD}` : 
  API_ENDPOINTS.LEAD; // URL relativa para proxy

// Debug apenas em desenvolvimento
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Ambiente:', process.env.NODE_ENV);
  console.log('🌐 Hostname:', typeof window !== 'undefined' ? window.location.hostname : 'SSR');
  console.log('🔗 WORKER_API_URL:', WORKER_API_URL);
  console.log('📡 LEAD_API_URL configurada:', LEAD_API_URL);
}

// Configurações de requisição
export const API_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest', // Header para identificar requisições AJAX
  },
  timeout: 10000, // 10 segundos
};

// Função para enviar lead com timeout e retry
export const sendLead = async (leadData) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), API_CONFIG.timeout);
  
  try {
    if (process.env.NODE_ENV === 'development') {
      console.log('📤 Enviando lead para:', LEAD_API_URL);
      console.log('📋 Dados do lead:', leadData);
    }
    
    const response = await fetch(LEAD_API_URL, {
      method: 'POST',
      headers: API_CONFIG.headers,
      body: JSON.stringify(leadData),
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      const errorText = await response.text().catch(() => 'Erro desconhecido');
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }
    
    const result = await response.json();
    
    if (process.env.NODE_ENV === 'development') {
      console.log('✅ Resposta do Worker:', result);
    }
    
    return { success: true, data: result };
    
  } catch (error) {
    clearTimeout(timeoutId);
    
    let errorMessage = 'Erro interno do servidor';
    
    if (error.name === 'AbortError') {
      errorMessage = 'Timeout na requisição - tente novamente';
    } else if (error.message.includes('Failed to fetch')) {
      errorMessage = 'Erro de conexão - verifique sua internet';
    } else if (error.message.includes('HTTP 403')) {
      errorMessage = 'Acesso negado - site não autorizado';
    } else if (error.message.includes('HTTP')) {
      errorMessage = error.message;
    }
    
    console.error('❌ Erro ao enviar lead:', error);
    return { success: false, error: errorMessage };
  }
}; 